import { render, staticRenderFns } from "./AS_TanUpdateold.vue?vue&type=template&id=6be447f0&scoped=true&"
import script from "./AS_TanUpdateold.vue?vue&type=script&lang=js&"
export * from "./AS_TanUpdateold.vue?vue&type=script&lang=js&"
import style0 from "./AS_TanUpdateold.vue?vue&type=style&index=0&id=6be447f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be447f0",
  null
  
)

export default component.exports